import React, { useState } from 'react';
import { connect } from 'react-redux';
import OutsideClickHandler from 'react-outside-click-handler';

import UserMenu from 'containers/UserMenu';

import { Creators as FormCreators } from 'store/ducks/serviceForm';
import { Creators as AuthCreators } from 'store/ducks/auth';

import {
  Container,
  Nav,
  List,
  A,
  WrapItem,
  Icon,
  BtnNewTask,
  ContentHeader,
  ContentUser,
  InfoUser,
  ImageUser,
  SubtitleUser,
  TitleUser,
} from './styles';
import { gaSendEvent } from '../../utils/analytics';

const goToEvent = (to) => {
  if (to === 'pedidos') gaSendEvent('meus_pedidos', 'sidebar');
  gaSendEvent('sidebar', to);
};

const createTask = (_openForm, _finishForm) => {
  gaSendEvent('novo_pedido', 'sidebar');
  _openForm({
    isOpen: true,
    isFormAddress: false,
    address: null,
    onFinish: _finishForm,
    selectedAddress: null,
  });
};

const Item = ({
  to, isExact, srcIcon, label, minimized,
}) => (
  <li>
    <A
      to={to}
      onClick={() => goToEvent(to.substring(1))}
      activeClassName="active"
      exact={isExact}
      svg={srcIcon}
    >
      <WrapItem minimized={minimized}>
        <Icon svg={srcIcon} />
        {!minimized && <span>{label}</span>}
      </WrapItem>
    </A>
  </li>
);

const SideBar = ({
  options, triiderUser, _logout, _openForm, _finishForm,
}) => {
  const [isOpenModalUser, setModalUser] = useState(false);
  const [minimized, setMinimized] = useState(true);
  const userName = triiderUser.user.name.toString().split(' ')[0];


  return (
    <Container
      onMouseEnter={() => setMinimized(false)}
      onMouseLeave={() => setMinimized(true)}
      minimized={minimized}
    >
      <ContentHeader>
        <ContentUser
          isOpen={isOpenModalUser}
          minimized={minimized}
          onClick={() => setModalUser(!isOpenModalUser)}
        >
          <ImageUser minimized={minimized} src={triiderUser.user.profile_picture || `https://ui-avatars.com/api/?background=FF7700&color=fff&name=${triiderUser.user.name && triiderUser.user.name.replace(' ', '%20')}`} />
          {!minimized && (
            <InfoUser minimized={minimized}>
              <TitleUser>{userName}</TitleUser>
              <SubtitleUser>
                {triiderUser.company.name && triiderUser.company.name.length > 12
                  ? `${triiderUser.company.name.substring(12, 0)}...`
                  : triiderUser.company.name
                }
              </SubtitleUser>
            </InfoUser>
          )}
        </ContentUser>
      </ContentHeader>
      <OutsideClickHandler onOutsideClick={() => setModalUser(false)}>
        <UserMenu
          minimized={minimized}
          isOpen={isOpenModalUser}
          logout={_logout}
          userName={triiderUser.user.name}
          emailUser={triiderUser.user.email}
          userImage={triiderUser.user.profile_picture || `https://ui-avatars.com/api/?background=FF7700&color=fff&name=${triiderUser.user.name && triiderUser.user.name.replace(' ', '%20')}`}
          userId={triiderUser.user.id}
        />
      </OutsideClickHandler>

      <BtnNewTask
        type="button"
        minimized={minimized}
        onClick={() => createTask(_openForm, _finishForm)}
      >
        {!minimized && <span>Novo pedido</span>}
      </BtnNewTask>
      <Nav>
        <List>
          {options.map((item, i) => (
            <Item minimized={minimized} {...item} key={i} isExact={i === 0} />
          ))}
        </List>
      </Nav>
    </Container>
  );
};

const mapStateToProps = state => ({
  triiderUser: state.auth.triiderUser,
});

const mapDispatchToProps = {
  _openForm: FormCreators.openForm,
  _finishForm: FormCreators.finishFormRequest,
  _logout: AuthCreators.logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
